import { PropertyFilterQuery } from '@cloudscape-design/collection-hooks';

import { BasicEscapeRoom } from './types';

function filterOperator(a: boolean, b: boolean, operator: 'and' | 'or') {
  return operator === 'and' ? a && b : a || b;
}

export function filterRoom(item: BasicEscapeRoom, query: PropertyFilterQuery) {
  let matches = query.operation === 'and';

  for (const token of query.tokens) {
    if (token.propertyKey === 'difficulty') {
      if (token.operator === '=') {
        matches = filterOperator(
          matches,
          item.difficulty === token.value.toLowerCase(),
          query.operation,
        );
      } else if (token.operator === '!=') {
        matches = filterOperator(
          matches,
          item.difficulty !== token.value.toLowerCase(),
          query.operation,
        );
      }
    } else if (token.propertyKey === 'status') {
      if (token.operator === '=') {
        matches = filterOperator(
          matches,
          item.escaped === (token.value.toLowerCase() === 'escaped'),
          query.operation,
        );
      } else if (token.operator === '!=') {
        matches = filterOperator(
          matches,
          item.escaped !== (token.value.toLowerCase() === 'escaped'),
          query.operation,
        );
      }
    }
  }

  return matches;
}
